import { Component, inject, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { IconSetService } from '@coreui/icons-angular';
import { iconSubset } from './icons/icon-subset';
import { Title } from '@angular/platform-browser';
import { getToken, Messaging, onMessage } from '@angular/fire/messaging';
import { from, share, tap } from 'rxjs';

@Component({
  selector: 'app-root',
 // template: '<router-outlet></router-outlet>',
   template: '<ngx-ui-loader></ngx-ui-loader><router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  title = "Shanbag's Classes";

  private readonly _messaging = inject(Messaging);

  constructor(
    private router: Router,
    private titleService: Title,
    private iconSetService: IconSetService
  ) {
    titleService.setTitle(this.title);
    // iconSet singleton
    iconSetService.icons = { ...iconSubset };
  }

  ngOnInit(): void {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
    });  

    
      this._onMessage()
  }

  private _onMessage(): void {
    onMessage(this._messaging, {
      next: (payload) => {
        console.log(payload);
        
        const notification = new Notification(payload.notification?.title, { body: payload.notification.body });
      },
      error: (error) => console.log('Message error', error),
      complete: () => console.log('Done listening to messages'),
    });
  }
}
